import { TPurchaseTokensResponse } from '.';
import RetroIconSVG from '../RetroIconSVG';
import PaymentForm from './payment-form';

interface IPurchaseCheckout {
  tokenOrder: TPurchaseTokensResponse | null;
  handlePaymentCompleted: () => void;
}

export const PurchaseCheckout = ({
  tokenOrder,
  handlePaymentCompleted,
}: IPurchaseCheckout) => {
  return (
    <div className="tokenPurchaseCheckout">
      <RetroIconSVG fname="arcade-checkout-icon" />
      <h3>Checkout</h3>

      <PaymentForm
        tokenOrder={tokenOrder}
        completionHandler={handlePaymentCompleted}
      />

      <style jsx>{`
        :global(.adyen-checkout__payment-methods-list *) {
          font-family: 'Montserrat', sans-serif !important;
        }
      `}</style>
    </div>
  );
};
